<div class="header">
  <actions [actionstrip]="actions" (clickAction)="onClickAction($event)"></actions>
</div>
<div class="container" *ngIf="value && value.rows">
  <div class="chart" [ngStyle]="{ width: 'calc(12em * ' + value.max + ')' }">
    <shared-route-chart-row [value]="row" *ngFor="let row of rowsList" [ngClass]="row.type"></shared-route-chart-row>
  </div>
</div>